module.exports = __webpack_public_path__ + "img/1 (50).99238b40.png";